import { Paper, Stack, Typography } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { ExternalActionDescription } from 'components/scenarios/common/ExternalActionDescription'
import { GRAPH_NODE_PAPER_PROPS } from 'components/scenarios/concurrent/concurrent-scenario-form-utils'
import { GraphNodeGlyphIcon } from 'components/scenarios/concurrent/GraphNodeGlyphIcon'
import { muiTheme } from 'mui-theme'
import {
  type ExternalActionNode,
  type GraphNode,
  type RollbackExternalActionNode,
  ScenarioLifecycle
} from 'types/api/scenarios/scenario'

export const ExternalActionGraphNode: React.FC<{
  node: ExternalActionNode | RollbackExternalActionNode
  isClickable?: boolean
  rowActions?: React.ReactNode
  onClick?: (node: GraphNode) => void
}> = ({ node, isClickable = false, rowActions, onClick }) => {
  return (
    <Paper
      data-testid={`external-action-graph-node-${node.guid}`}
      sx={[
        GRAPH_NODE_PAPER_PROPS,
        !rowActions && { paddingRight: 2 },
        (muiTheme) => ({
          marginY: muiTheme.spacing(2)
        })
      ]}
      {...(isClickable && onClick && { onClick: () => onClick(node) })}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          <GraphNodeGlyphIcon node={node} />
          <Stack sx={{ maxWidth: '100%' }}>
            <ExternalActionDescription node={node} />
            {node.state.lifecycle === ScenarioLifecycle.Failed ? (
              <Stack
                alignItems="center"
                direction="row"
                flexWrap="nowrap"
                spacing={0.5}
              >
                <Typography color="error">
                  <Icon
                    css={{ marginRight: muiTheme.spacing(0.5) }}
                    icon="solidWarning"
                  />
                  <Typography color="inherit" variant="caption">
                    {node.state.failed_reason
                      ? `This action did not occur because ${node.state.failed_reason}`
                      : 'An unknown error occurred'}
                  </Typography>
                </Typography>
              </Stack>
            ) : null}
          </Stack>
        </Stack>

        {rowActions && (
          <Stack
            sx={{
              justifyContent: 'center',
              alignContent: 'center'
            }}
          >
            {rowActions}
          </Stack>
        )}
      </Stack>
    </Paper>
  )
}
